<template>
  <div class="cus-chat-supervise">
    <div class="cus-chat-supervise-search">
      <el-form :inline="true">
        <el-form-item label="群名称：">
          <el-input
            v-model="formInline.chatName"
            size="mini"
            clearable
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="群主：">
          <el-input
            v-model="formInline.ownerName"
            size="mini"
            clearable
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="群标签：">
          <el-cascader
            v-model="searchTagItem"
            :options="tagList"
            :props="tagProps"
            size="mini"
            @change="selectTagItem"
            :show-all-levels="false"
          />
        </el-form-item>
        <el-form-item label="建群时间：">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="small"
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="最近聊天时间：">
          <el-date-picker
            v-model="date2"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="small"
            @change="selectBindStatus2"
          />
        </el-form-item>
        <el-form-item v-if="isShow">
          <el-button size="small" @click="handleGetData" v-show="handleDta"
            >同步数据</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <el-table
        size="small"
        :data="tableData"
        fit
        highlight-current-row
        align="center"
        :header-cell-style="{ background: '#eef1f6' }"
        :height="tableHeight"
        ref="cusChatTable"
        @sort-change="tableSort"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="!isShow">
        </el-table-column>
        <el-table-column
          prop="chatName"
          label="群名称"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="ownerName" label="群主" align="center">
        </el-table-column>
        <el-table-column
          prop="groupChatTagDetailDtoList"
          label="群标签"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              v-for="item in scope.row.groupChatTagDetailDtoList"
              :key="item.tagId"
              size="small"
              style="margin: 3px"
            >
              <el-popover placement="bottom-start" width="150" trigger="hover">
                <span slot="reference">{{ item.tagName }}</span>
                <el-tag
                  v-for="item in scope.row.groupChatTagDetailDtoList"
                  :key="item.tagId"
                  size="small"
                  style="margin: 3px"
                  closable
                  @close="deleteGroupTag(scope.row.chatId, item.tagId)"
                  >{{ item.tagName }}</el-tag
                >
              </el-popover>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="memNum" label="群人数" align="center">
        </el-table-column>
        <el-table-column
          prop="memQuitNum"
          label="退群人数"
          align="center"
          v-if="isShow"
        >
        </el-table-column>
        <el-table-column
          prop="dayMemQuitNum"
          label="当天进群/退群人数"
          align="center"
          v-if="isShow"
        >
          <template slot-scope="scope">
            <span
              >{{
                scope.row.dayMemJoinNum > 0 ? "+" + scope.row.dayMemJoinNum : 0
              }}/{{
                scope.row.dayMemQuitNum > 0 ? "-" + scope.row.dayMemQuitNum : 0
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="建群时间"
          align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="lastActivityTime"
          label="最近聊天时间"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lastActivityTime || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="operation"
          label="操作"
          align="center"
          v-if="isShow"
        >
          <template slot-scope="scope">
            <el-button
              :underline="false"
              type="text"
              v-show="handleDetail"
              @click.native="viewDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              :underline="false"
              type="text"
              @click.native="tagClick(scope.row.chatId, scope.row)"
              v-show="handleTag"
              >打标签</el-button
            >
            <el-button
              :underline="false"
              type="text"
              @click.native="viewContent(scope.$index, scope.row)"
              v-show="handleChat"
              >聊天记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>

    <el-dialog
      :title="chatTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
      :center="true"
      :close-on-press-escape="true"
      @close="close"
    >
      <div style="">
        <!-- 聊天组件 -->
        <GroupChatDia v-if="newEditionDialogVisible" :idData="uid" />
        <!--  v-if="environment === 'other' || !isNewEdition" -->
        <!-- <groupChatView v-if="environment === 'other' || !isNewEdition"  :idData="uid" /> -->
      </div>
    </el-dialog>
    <el-dialog
      title="群标签"
      :visible.sync="tagVisible"
      :close-on-click-modal="false"
      width="50%"
      close-on-press-escape
      v-if="tagVisible"
    >
      <Tag
        :is-show="false"
        :currentRow="currentRow"
        @addTag="addGroupTag"
        @handleBack="tagVisible = false"
      />
    </el-dialog>
  </div>
</template>
<script>
// import { getChatQwAndYuanNeiCUstomer } from '../../api/customer/customer.js'
import { deleteGroupTag } from "../../api/group/index.js";
import {
  getList,
  getTagList,
  getGroupMessage,
  addTagItems,
  deleteGroupTags,
} from "../../api/group/index.js";
import { getSessionVersion } from "@/api/staff/staff.js";
import groupChatView from "./components/groupChatView";
/** 聊天组件 */
import GroupChatDia from "./components/newGroupChat/groupChatDia";
import Tag from "./tag.vue";
import dayjs from "dayjs";
export default {
  name: "CusChatSupervise",
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    groupChatView,
    GroupChatDia,
    Tag,
  },
  data() {
    return {
      tableData: [],
      tableHeight: 500,
      dialogVisible: false,
      currentRow: null,
      // loading: true,
      uid: "",
      chatTitle: "",
      options: [
        {
          bindStatus: 10,
          label: "不限",
        },
        {
          bindStatus: 1,
          label: "已绑定档案",
        },
        {
          bindStatus: 0,
          label: "未绑定档案",
        },
      ],
      pageparm: {
        pageNum: 1,
        pageSize: 20,
        total: 10,
      },

      formInline: {
        pageNum: 1,
        pageSize: 20,
        chatName: "",
        ownerName: "",
        tagId: [],
        startTime: "",
        endTime: "",
        chatStartTime: "",
        chatEndTime: "",
        createTimeOrder: "",
        lastActivityOrder: "",
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      date: null,
      date2: null,
      tagList: [],
      tagVisible: false,
      currentTagId: "",
      tagProps: {
        multiple: true, //是否允许多选
        label: "tagName",
        value: "tagId",
        children: "groupChatTagDetailDtoList",
        showAllLevels: false,
        // checkStrictly: true
        // checkStrictly: true
        // emitPath: false
      },
      addTagItem: [],
      searchTagItem: [],
      handleTag: false, //打标签是否可见
      handleChat: false, //聊天记录是否可见
      handleDta: false, //可同步数据是否可见
      handleDetail: false, //详情是否可见
      /** 是否新版本会话 true新版 false旧版*/
      isNewEdition: true,
      /** 当前所属环境 com-wx-mobile手机端企业微 com-wx-pc电脑端企微 other其他环境（外部浏览器）*/
      // environment: "",
      // 提示实例，防止弹出多个提示
      messageInstance: null,
      // 控制聊天记录弹窗显示隐藏
      newEditionDialogVisible: false,
    };
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("XXXXXXXX", newVal);
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "群列表") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("qglkdbq") != -1) {
                // 可打标签
                this.handleTag = true;
              } else {
                this.handleTag = false;
              }
              if (senBtnAuthority.indexOf("qglkckltjl") != -1) {
                // 可查询聊天记录
                this.handleChat = true;
              } else {
                this.handleChat = false;
              }
              if (senBtnAuthority.indexOf("qglktbsj") != -1) {
                // 可同步数据按钮
                this.handleDta = true;
              } else {
                this.handleDta = false;
              }
              if (
                senBtnAuthority.indexOf("qglqxq") != -1 &&
                process.env.NODE_ENV === "development"
              ) {
                // 可查看详情（仅本地开发环境）
                this.handleDetail = true;
              } else {
                this.handleDetail = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query": {
      handler(oldVal, newVal) {
        console.log("监听路由", oldVal);
        if (oldVal && oldVal.startTime && oldVal.endTime) {
          this.formInline.startTime = oldVal.startTime + " " + "00:00:00";
          this.formInline.endTime = oldVal.endTime + " " + "23:59:59";

          this.formInline.chatStartTime =
            oldVal.chatStartTime + " " + "00:00:00";
          this.formInline.chatEndTime = oldVal.chatEndTime + " " + "23:59:59";

          this.date = [
            oldVal.startTime + " " + "00:00:00",
            oldVal.endTime + " " + "23:59:59",
          ];
          this.date2 = [
            oldVal.chatStartTime + " " + "00:00:00",
            oldVal.chatEndTime + " " + "23:59:59",
          ];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    /** 获取当前环境 */
    // this.environment =
    //   window.localStorage.getItem("environment") ||
    //   (await this.getEnvironment());
    /** 获取判断新旧版本参数 */
    // await this.getVersionsParams();
    this.getList(this.formInline);
    this.getTag();
    // setTimeout(()=>{
    //   console.log("this.btnAuthority",this.btnAuthority)
    // })
    // console.log('testtest')
  },
  methods: {
    handleSelectionChange(val) {
      console.log(val);
      this.$emit("subGroup", val);
    },
    handleGetData() {
      this.$confirm("确定执行该操作吗?", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      }).then((res) => {
        getGroupMessage(localStorage.getItem("Authorization"))
          .then((res) => {
            this.$message.success(`操作成功`);
          })
          .catch(() => {
            this.$message.error(`操作失败，请重新尝试`);
          });
      });
    },
    selectTagItem(list) {
      let tagList = [];
      if (list.length > 0) {
        list.forEach((item) => {
          tagList.push(item[1]);
        });
      }
      this.formInline.tagId = [...tagList];
      this.getList(this.formInline);
    },
    // 群聊打标签
    addGroupTag(row) {
      this.addTagItem = [];
      row.forEach((item) => {
        if (item.groupChatTagDetailDtoList.length > 0) {
          item.groupChatTagDetailDtoList.forEach((item1) => {
            if (item1.type == 1) {
              this.addTagItem.push(item1.tagId);
            }
          });
        }
      });
      addTagItems(localStorage.getItem("Authorization"), {
        chatId: this.currentTagId,
        tagId: this.addTagItem,
      }).then((res) => {
        console.log(9999, res);

        if (res.error.code == 200) {
          this.$message({
            type: "success",
            message: res.error.message,
          });
          this.tagVisible = false;
          this.getList(this.formInline);
        } else {
          this.$message({
            type: "error",
            message: res.error.message,
          });
        }
      });
    },
    // 删除群聊打标签
    deleteGroupTag(chatId, tagId) {
      this.$confirm("确定删除该标签吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteGroupTags(localStorage.getItem("Authorization"), {
            chatId,
            tagId,
          }).then((res) => {
            if (res.error.code == 200) {
              this.$message({
                type: "success",
                message: res.error.message,
              });
              this.tagVisible = false;
              this.getList(this.formInline);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 显示打标签弹窗
    tagClick(currentTagId, row) {
      this.tagVisible = true;
      this.currentTagId = currentTagId;
      this.currentRow = row;
    },
    getTag() {
      getTagList(localStorage.getItem("Authorization")).then((res) => {
        console.log(res);
        this.tagList = res.data.map((item) => {
          return { ...item, tagName: item.groupName };
        });
      });
    },
    selectBindStatus() {
      this.formInline.pageNum = 1;
      if (this.date != null) {
        this.formInline.startTime = dayjs(this.date[0]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        this.formInline.endTime =
          dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.formInline.startTime = "";
        this.formInline.endTime = "";
      }
      // /** 最近聊天开始时间 */
      // if (this.date2 != null) {
      //   this.formInline.chatStartTime = dayjs(this.date2[0]).format(
      //     "YYYY-MM-DD HH:mm:ss"
      //   );
      //   this.formInline.chatEndTime =
      //     dayjs(this.date2[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      // } else {
      //   this.formInline.chatStartTime = "";
      //   this.formInline.chatEndTime = "";
      // }
      this.getList(this.formInline);
    },

    selectBindStatus2() {
      this.formInline.pageNum = 1;
      /** 最近聊天开始时间 */
      if (this.date2 != null) {
        this.formInline.chatStartTime = dayjs(this.date2[0]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        this.formInline.chatEndTime =
          dayjs(this.date2[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.formInline.chatStartTime = "";
        this.formInline.chatEndTime = "";
      }
      this.getList(this.formInline);
    },
    selectTime() {
      this.formInline.pageNum = 1;
      this.getList(this.formInline);
    },
    onInputBlur() {
      this.formInline.pageNum = 1;
      this.getList(this.formInline);
    },

    /** 获取群聊列表 */
    getList(parameter) {
      // if (this.isNewEdition && this.environment !== 'other') {
      // if (this.isNewEdition && this.environment !== "other") {
      //   /** 新版走这里 */
      //   getGroupList(parameter, localStorage.getItem("Authorization"))
      //     .then((res) => {
      //       if (res && res.error && res.error.code == 200) {
      //         this.tableData = res.data.rows;
      //         this.pageparm.total = res.data.count;
      //         this.pageparm.pageNum = this.formInline.pageNum;
      //         this.pageparm.pageSize = this.formInline.pageSize;
      //       } else {
      //         if (this.messageInstance) this.messageInstance.close();
      //         this.messageInstance = this.$message.error(
      //           "获取失败，请稍后再试"
      //         );
      //       }
      //     })
      //     .catch((err) => {
      //       if (this.messageInstance) this.messageInstance.close();
      //       this.messageInstance = this.$message.error("获取失败，请稍后再试");
      //       console.log("获取新版员工失败", err);
      //     });
      // } else {
      getList(parameter, localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          if (res.data.rows.length > 0) {
            this.tableData = res.data.rows;
            this.pageparm.total = res.data.count;
            this.pageparm.pageNum = this.formInline.pageNum;
            this.pageparm.pageSize = this.formInline.pageSize;
          } else {
            this.tableData = [];
          }
        }
      });
      // }
    },

    search() {
      this.formInline.pageNum = 1;
      this.getList(this.formInline);
    },

    clear() {
      this.formInline.name = "";
    },

    test(index, row) {
      console.log(row);
      /** 赋值群聊id */
      this.uid = row.chatId;
      this.dialogVisible = true;
      this.chatTitle = row.chatName;
    },

    /** 查看聊天记录 */
    viewContent(index, row) {
      console.log(row);
      /** 赋值群聊id */
      this.uid = row.chatId;
      this.dialogVisible = true;
      this.newEditionDialogVisible = true;
      this.chatTitle = row.chatName;
    },

    /** 查看群详情 */
    viewDetail(row) {
      this.$router.push({
        name: "groupDetail",
        query: { chatId: row.chatId },
      });
    },
    controlHeight() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
      window.addEventListener("resize", this.setTableHeight);
    },
    setTableHeight() {
      const wrapper = this.$refs.tableWrapper;
      if (wrapper) {
        this.tableHeight = wrapper.clientHeight;
      }
    },
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getList(this.formInline);
    },

    /** 获取判断新旧版本参数（参数由总控控制，必须最先执行完在执行获取列表数据） */
    async getVersionsParams() {
      await getSessionVersion(localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.isNewEdition = res.data;
            console.log("ssgdfg", this.isNewEdition);
            window.localStorage.setItem("isNewEdition", this.isNewEdition);
          } else {
            this.$message.error("获取版本参数失败");
          }
        })
        .catch((err) => {
          this.$message.error("获取版本参数失败");
          console.log("新旧版本参数获取失败", err);
        });
    },

    /** 弹窗关闭 */
    close() {
      console.log("弹窗关闭");
      this.dialogVisible = false;
      // 把新版聊天组件弹窗销毁
      this.newEditionDialogVisible = false;
    },

    /** 点击排序触发 */
    tableSort({ column, prop, order }) {
      console.log("column++++", column);
      console.log("prop++++", prop);
      console.log("order++++", order);
      if (order === "ascending") {
        if (prop === "lastActivityTime") {
          this.formInline.lastActivityOrder = "ASC";
          this.formInline.createTimeOrder = "";
        } else {
          this.formInline.createTimeOrder = "ASC";
          this.formInline.lastActivityOrder = "";
        }
      } else {
        if (prop === "lastActivityTime") {
          this.formInline.lastActivityOrder = "DESC";
          this.formInline.createTimeOrder = "";
        } else {
          this.formInline.createTimeOrder = "DESC";
          this.formInline.lastActivityOrder = "";
        }
      }
      this.getList(this.formInline);
    },

    /** 获取当前环境 */
    // getEnvironment() {
    //   let isMobile = window.navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   ); // 是否手机端
    //   let isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
    //   if (isComWx && isMobile) {
    //     //手机端企业微信
    //     this.environment = "com-wx-mobile";
    //   } else if (isComWx && !isMobile) {
    //     //PC端企业微信
    //     this.environment = "com-wx-pc";
    //   } else {
    //     //其他环境
    //     this.environment = "other";
    //   }
    //   window.localStorage.setItem("environment", this.environment);
    // },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["cusChatTable"].doLayout();
    });
  },
  mounted: function() {
    this.controlHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setTableHeight);
  },
};
</script>
<style lang="scss" scoped>
.cus-chat-supervise {
  height: 100%;
  display: flex;
  flex-direction: column;

  .cus-chat-supervise-search {
    margin-bottom: 10px;
    flex-shrink: 0;
  }

  .table-wrapper {
    flex: 1;
    min-height: 0;
  }

  .el-dialog {
    min-width: 620px;
    max-width: 1200px;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #0f0f0f;
  }

  .el-dialog__body {
    padding: 5px 30px 20px !important;
  }
}
</style>
